import { render, staticRenderFns } from "./OrgEditTabAccount.vue?vue&type=template&id=624c01ad&"
import script from "./OrgEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./OrgEditTabAccount.vue?vue&type=script&lang=js&"
import style0 from "./OrgEditTabAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports